import PropTypes from 'prop-types'
import { TableBody, Table, TableCell, TableHead, TableRow } from '@mui/material'
import ContractExtrasRow from './ContractExtrasRow'

const extrasHeaders = ['Nazwa', 'Ilość', 'Cena', 'Wartość']

const ContractExtrasTable = ({
  extras,
  formik,
  handleChange,
  deleteRow,
  finalize,
  edit,
}) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          {extrasHeaders &&
            extrasHeaders.map((header, index) => (
              <TableCell
                key={index}
                style={{
                  width: `${100 / extrasHeaders.length}%`,
                  whiteSpace: 'nowrap',
                }}
              >
                {header}
              </TableCell>
            ))}
          {!(finalize || edit) && <TableCell>Akcja</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {extras &&
          formik.values.extras &&
          Object.keys(formik.values.extras).length &&
          Object.keys(formik.values.extras).map((key) => (
            <ContractExtrasRow
              key={key}
              formik={formik}
              handleChange={handleChange}
              deleteRow={deleteRow}
              keyString={key}
              extras={extras}
              finalize={finalize}
              edit={edit}
            />
          ))}
      </TableBody>
    </Table>
  )
}

ContractExtrasTable.propTypes = {
  extras: PropTypes.array,
  formik: PropTypes.object,
  handleChange: PropTypes.func,
  deleteRow: PropTypes.func,
  finalize: PropTypes.bool,
  edit: PropTypes.bool,
}

export default ContractExtrasTable
